

import { Component, forwardRef, Inject, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { WorkflowApplicationsJanusService } from '../workflow-applications-janus.service';
import { debounceTime, distinctUntilChanged, ReplaySubject, Subject, Subscription, switchMap } from 'rxjs';
import { CommonTableComponent, TableColumn } from 'src/app/components/common/common-table/common-table.component';
import { ParcelNotesCellComponent } from 'src/app/components/workflow/activities/search-parcel-data-activity-editor/search-parcel-data-activity-input/parcel-notes-cell.component';
import { DataService, WorkflowContextService } from 'src/app/services';
import { SearchParcelDataCriteria } from 'src/app/models/search-parcel-data-criteria';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalConfirmComponent } from 'src/app/components/system/modal-confirm/modal-confirm.component';
import { ItemSearchOptionField, ItemSearchOptionFieldOption } from 'src/app/components/filter-list/models/filterClasses';

@Component({
  selector: 'app-parcels-janus',
  standalone: false,
  templateUrl: './parcels-janus.component.html',
  styleUrl: './parcels-janus.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class ParcelsJanusComponent implements OnInit {

  parcelId: string = ''
  propertyOwner: string = ''
  propertyAddress: string = ''
  results: any[] = [];
  isLoading = false;
  columns: TableColumn[];
  selectedIds = new Set<string>();   // stores selected parcelIDs

  allResults: any[] = [];   // full dataset

  pageSize = 20;
  currentPage = 0;
  totalPages = 0;
  selectedParcelForNotes: any;
  canViewInternalParcelNotes: boolean;
  canManageParcelNotes: boolean;
  // Added by Amisha on 2026-06-26 to track when parcel notes are occupying the table area as an overlay.
  // Reason: the parcels tab needs the same temporary frame switch used by Janus data-table overlays.
  isParcelNotesOverlayOpen = false;
  publicNote: string;
  internalNote: string;
  private subscription!: Subscription;

  trimmedResults: any[] = [];

  @ViewChild('ParcelNotesModal', { static: false }) parcelNotesModal: ModalConfirmComponent;
  constructor(
    private workflowApplicationsJanusSvc: WorkflowApplicationsJanusService,
    private dataService: DataService,
    private _context: WorkflowContextService,
    private router: Router,
    @Inject(forwardRef(() => DataService)) private _dataSvc: DataService,
  ) { }

  private applyPaging() {
    const start = this.currentPage * this.pageSize;
    const end = start + this.pageSize;

    this.results = this.allResults.slice(start, end);
    this.results.forEach(r => {
      r.selected = this.selectedIds.has(r.parcelID);
    });
  }
  onRowToggle(row: any) {
    // row.selected = !row.selected;

    if (row.selected) {
      this.selectedIds.add(row.parcelID);
    } else {
      this.selectedIds.delete(row.parcelID);
    }
    const currentData = this.workflowApplicationsJanusSvc.getData();
    const currentFilterInputs = currentData.filterInputs || [];

    // Remove existing parcelId filter
    const otherFilters = currentFilterInputs.filter(
      f => f.title !== 'parcelId'
    );

    const idsArray = Array.from(this.selectedIds);

    // If nothing selected → remove filter completely
    if (idsArray.length === 0) {
      this.workflowApplicationsJanusSvc.setData({
        ...currentData,
        filterInputs: otherFilters
      });
      return;
    }

    const searchText = idsArray.join(', ');
    const strOperator = idsArray.length > 1 ? 'in' : '';

    const parcelFilter = new ItemSearchOptionField({
      title: 'parcelId',
      options: [
        new ItemSearchOptionFieldOption({
          searchText: searchText,
          searchOptionMethod: '',
          strOperator: strOperator,
          filterText: '',
          selected: true,
          title:'parcelId'
        })
      ]
    });

    // code edited by krutika
    // this.workflowApplicationsJanusSvc.setData({
    //   ...currentData,
    //   filterInputs: [...otherFilters, parcelFilter]
    // });

    const updatedFilters = [...otherFilters, parcelFilter];

// ✅ Update service
this.workflowApplicationsJanusSvc.setData({
  ...currentData,
  filterInputs: updatedFilters
});

// ✅ SAVE TO LOCAL STORAGE (🔥 THIS WAS MISSING)
localStorage.setItem(
  'workflow-applications-filters',
  JSON.stringify({
    filterInputs: updatedFilters,
    attributeFilterInputs: currentData?.attributeFilterInputs || []
  })
);

    // end code by krutika
    // 1 filter multiple options
    // ------------------------

    // const currentData = this.workflowApplicationsJanusSvc.getData();
    // const currentFilterInputs = currentData.filterInputs || [];

    // // Separate parcelId filter from other filters
    // const otherFilters = currentFilterInputs.filter(
    //   f => f.title !== 'parcelId'
    // );

    // let existingParcelFilter = currentFilterInputs.find(
    //   f => f.title === 'parcelId'
    // );

    // // If parcel filter exists, get its options
    // let existingOptions = existingParcelFilter?.options || [];

    // existingOptions = existingOptions.filter(option =>
    //   this.selectedIds.has(option.searchText)
    // );
    // this.selectedIds.forEach(id => {
    //   const alreadyExists = existingOptions.some(
    //     option => option.searchText === id
    //   );

    //   if (!alreadyExists) {
    //     existingOptions.push(
    //       new ItemSearchOptionFieldOption({
    //         title: 'parcelId',
    //         selected: true,
    //         searchText: id,
    //         filterText: '',
    //         strOperator: '',
    //         searchOptionMethod: ''
    //       })
    //     );
    //   }
    // });



    // const updatedParcelFilter = new ItemSearchOptionField({
    //   title: 'parcelId',
    //   options: existingOptions
    // });


    // this.workflowApplicationsJanusSvc.setData({
    //   ...currentData,
    //   filterInputs: [...otherFilters, updatedParcelFilter]
    // });

    // -------------------

    // for each option 1 filter
    // -----------------------
    // const currentData = this.workflowApplicationsJanusSvc.getData();
    // const currentFilterInputs = currentData.filterInputs || [];

    // // Remove old parcelId filters completely
    // const otherFilters = currentFilterInputs.filter(
    //   filter => filter.title !== 'parcelId'
    // );

    // // Build new parcelId filters (one per id)
    // const parcelFilters: ItemSearchOptionField[] = Array.from(this.selectedIds).map(id =>
    //   new ItemSearchOptionField({
    //     title: 'parcelId',
    //     options: [
    //       new ItemSearchOptionFieldOption({
    //         title: 'parcelId',
    //         selected: true,
    //         searchText: id,
    //         searchOptionMethod: '',
    //         strOperator: '',
    //         filterText: ''
    //       })
    //     ]
    //   })
    // );

    // // Set final state
    // this.workflowApplicationsJanusSvc.setData({
    //   ...currentData,
    //   filterInputs: [...otherFilters, ...parcelFilters]
    // });
    // ------------------------

  }

  onHeaderToggle(rows: any[]) {

  rows.forEach(row => {
    if (row.selected) {
      this.selectedIds.add(row.parcelID);
    } else {
      this.selectedIds.delete(row.parcelID);
    }
  });

  const currentData = this.workflowApplicationsJanusSvc.getData();
  const otherFilters = (currentData.filterInputs || []).filter(
    f => f.title !== 'parcelId'
  );

  const idsArray = Array.from(this.selectedIds);

  if (idsArray.length === 0) {
    this.workflowApplicationsJanusSvc.setData({
      ...currentData,
      filterInputs: otherFilters
    });
    return;
  }

  const parcelFilter = new ItemSearchOptionField({
    title: 'parcelId',
    options: [
      new ItemSearchOptionFieldOption({
        searchText: idsArray.join(', '),
        strOperator: idsArray.length > 1 ? 'in' : '',
        selected: true,
        title: 'parcelId',
        filterText: '',
        searchOptionMethod: ''
      })
    ]
  });

  this.workflowApplicationsJanusSvc.setData({
    ...currentData,
    filterInputs: [...otherFilters, parcelFilter]
  });
}
  toggleSelectAll(checked: boolean) {

    if (checked) {
      this.results.forEach(r => {
        r.selected = true;
        this.selectedIds.add(r.parcelID);
      });
    } else {
      this.results.forEach(r => {
        r.selected = false;
        this.selectedIds.delete(r.parcelID);
      });
    }

    this.results = [...this.results]; // refresh table

  }
  get isAllSelected(): boolean {
    return this.results.length > 0 &&
      this.results.every(r => this.selectedIds.has(r.parcelID));
  }

  get isIndeterminate(): boolean {
    const selectedCount = this.results.filter(r => this.selectedIds.has(r.parcelID)).length;
    return selectedCount > 0 && selectedCount < this.results.length;
  }

  setSubscription() {
    this.workflowApplicationsJanusSvc.data$.subscribe(data => {
        if (!this.router.url.includes('/parcels')) {
    return;
  }
      this.parcelId = data.parcelId
      this.propertyAddress = data.propertyAddress
      this.propertyOwner = data.propertyOwner
      // Extract and split comma-separated ids
      
      // const commonSearch =data.searchText?.[0]?.options?.[0]?.searchText || '';
      const commonSearch = data.searchText?.flatMap(x => x.options || [])?.find(x => x.filterText)?.filterText || '';
      const ids = data.filterInputs
        ?.filter(f => f.title === 'parcelId')
        .flatMap(f =>
          f.options?.[0]?.searchText
            ?.split(',')
            .map(id => id.trim()) || []
        ) || [];

      this.selectedIds = new Set(ids);
      this.loadparceldata(this.parcelId, this.propertyOwner, this.propertyAddress, commonSearch)
    })

  }

  loadparceldata(parcelId?: string, propertyOwner?: string, propertyAddress?: string, commonSearch?: string) {
    const payload = new SearchParcelDataCriteria({
      clientId: this._context.client?.id,
      maxResults: 200,

      searchParcelId: parcelId,
      searchParcelOwnerName: propertyOwner,
      searchParcelAddress: propertyAddress,

      searchParcelIds: [],
      searchWorkflowApplications: false
    });

    this.subscription = this.dataService.getParcelDataSourceResults(payload)
      .subscribe({
        next: (res) => {

          let filtered = res.filter((v, i) => i > 0);

          if (commonSearch?.trim()) {

            const search = commonSearch.toLowerCase();

            filtered = filtered.filter(item =>
              item.parcelID?.toLowerCase().includes(search) ||
              item.ownerName?.toLowerCase().includes(search) ||
              item.address?.toLowerCase().includes(search) ||
              item.city?.toLowerCase().includes(search)
            );
          }

          this.allResults = this.trimResultsByColumns(filtered, this.columns);

          this.totalPages = Math.ceil(this.allResults.length / this.pageSize);
          this.currentPage = 0;

          this.applyPaging();
          // this.loadPermissions();
          this.isLoading = false;

        },
        error: (err) => {
          this.isLoading = false;

        }
      })
  }


  // Deepak added code for sorting start 03/16/2026
    onSortChange(event: any) {

  const { sortField, sortDescending } = event;

  if (!sortField) {
    this.applyPaging();
    return;
  }

  this.allResults = [...this.allResults].sort((a, b) => {

    let valA = a[sortField];
    let valB = b[sortField];

    if (valA == null) return 1;
    if (valB == null) return -1;

    if (valA < valB) return sortDescending ? 1 : -1;
    if (valA > valB) return sortDescending ? -1 : 1;

    return 0;
  });

  this.applyPaging();
}

// Deepak added code for sorting end 03/16/2026
  ngOnInit(): void {

    this.columns = [
      {
        key: 'selected',
        headerType: 'checkbox',
        width: '50px',
        cellType: 'checkbox',
      },
      {
        key: 'parcelID',
        label: 'Parcel ID',
        headerType: 'text',
        cellType: 'text',
      },
      {
        key: 'address',
        label: 'Address',
        headerType: 'text',
        cellType: 'text',
      },
      {
        key: 'city',
        label: 'City',
        headerType: 'text',
        cellType: 'text',
      },
      {
        key: 'ownerName',
        label: 'Owner Name',
        width: '280px',
        headerType: 'text',
        cellType: 'text',
      },
      {
        key: 'acres',
        label: 'Acres',
        headerType: 'text',
        cellType: 'text',
      },
      {
        key: 'notes',
        label: 'Notes',
        headerType: 'text',
        cellType: 'component',
        component: ParcelNotesCellComponent,
        width: '140px',
        componentInputs: (row: any) => ({

          row: {
            ...row,


            canManageParcelNotes: row.canManageParcelNotes === '1',
            canViewInternalParcelNotes: row.canViewInternalParcelNotes === '1'
          }
        }),
        componentOutputs: {
          notesClick: (row: any) => this.openParcelNotes(row)
        }
      }
    ]
    this.isLoading = true;
    this.setSubscription();


  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.applyPaging();
  }


  onRowsPerPageChange(size: number) {
    this.pageSize = size;
    this.currentPage = 0;
    this.totalPages = Math.ceil(this.allResults.length / this.pageSize);

    this.applyPaging();
  }


  openParcelNotes(row: any) {
    this.selectedParcelForNotes = row;


    this.canManageParcelNotes = row.canManageParcelNotes === true || row.canManageParcelNotes === '1';
    this.canViewInternalParcelNotes = row.canViewInternalParcelNotes === true || row.canViewInternalParcelNotes === '1';

    // Reset notes before loading
    this.publicNote = '';
    this.internalNote = '';
    // Added by Amisha on 2026-06-26 to put the parcels tab into overlay mode before the notes modal renders.
    // Reason: the shared table should hide fixed pagination and use the modal as the active scroll container.
    this.isParcelNotesOverlayOpen = true;
    this._context.applicationViewType$.emit('overlay');
    this.parcelNotesModal.open();
  }

  onParcelNotesClosed(): void {
    // Added by Amisha on 2026-06-26 to restore the parcels table frame after notes close.
    // Reason: pagination and internal table scrolling should return as soon as the overlay is dismissed.
    this.isParcelNotesOverlayOpen = false;
    this._context.applicationViewType$.emit('none');
  }


  private loadPermissions() {
    if (this.results.length > 0) {
      const result = this.results[0];
      this.canViewInternalParcelNotes =
        result['canViewInternalParcelNotes'] === '1' ? true : false;
      this.canManageParcelNotes =
        result['canManageParcelNotes'] === '1' ? true : false;
    }
  }

  trimResultsByColumns(data: any[], columns: any[]) {
    return data.map((item) => {
      return columns.reduce((acc: any, col: any) => {
        const key = col.key;

        if (item.hasOwnProperty(key)) {
          acc[key] = key === 'acres'
            ? parseFloat(item[key]).toFixed(3)
            : item[key];
        }
        else if (col.cellType === 'checkbox' || col.cellType === 'radio') {
          acc[key] = false;
        }

        return acc;
      }, {
        id: item.parcelID,
        internalNote: item.internalNote ?? '0',
        publicNote: item.publicNote ?? '0',

        // keep ORIGINAL string values here
        canViewInternalParcelNotes: item.canViewInternalParcelNotes ?? '0',
        canManageParcelNotes: item.canManageParcelNotes ?? '0'
      });
    });
  }




  notesModal(publicNotes: string, internalNotes: string, parcelId: string) {
    // Added by Amisha on 2026-06-26 to close overlay mode immediately on save.
    // Reason: the notes modal uses closeOnAccept, so the parcels view must proactively restore its base frame state.
    this.onParcelNotesClosed();

    publicNotes = publicNotes ? publicNotes : '';
    internalNotes = internalNotes ? internalNotes : '';

    this._dataSvc.saveParcelNote(publicNotes, internalNotes, parcelId)
      .subscribe(() => {

        // Update selected row locally
        const hasNote = publicNotes !== '' || internalNotes !== '';

        // Update ALL RESULTS
        const masterRow = this.allResults.find(r => r.parcelID === parcelId);
        if (masterRow) {
          masterRow.publicNote = hasNote ? publicNotes : '0';
          masterRow.internalNote = hasNote ? internalNotes : '0';
        }

        // Update CURRENT PAGE data
        const pageRow = this.results.find(r => r.parcelID === parcelId);
        if (pageRow) {
          pageRow.publicNote = hasNote ? publicNotes : '0';
          pageRow.internalNote = hasNote ? internalNotes : '0';
        }

        //  Force Angular refresh
        this.results = this.results.map(r => ({ ...r }));

      });
  }


  getParcelNote(parcelId: string) {
    this._dataSvc.getParcelNote(parcelId).subscribe(response => {
      this.internalNote = response.internalNote;
      this.publicNote = response.publicNote;
    });
  }

}
